'use client';

import { c as _c } from "react/compiler-runtime";
import PopupComponent, { type PopupComponentRef, PopupType } from '@spa/components/popup/popup.component';
import { ReactElement, useId, useRef } from 'react';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { createPortal } from 'react-dom';
import styles from './bazaarvoice-review-success-modal.component.module.scss';
import useHasOpenedOnce from '@spa/lib/react/hooks/useHasOpenedOnce';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly isOpen: boolean;
  readonly onClosed: () => void;
}
function BazaarvoiceReviewSuccessModalComponent(t0) {
  const $ = _c(24);
  const {
    isOpen,
    onClosed
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-success-modal");
  const hasOpened = useHasOpenedOnce(isOpen);
  const popupRef = useRef(null);
  const titleId = useId();
  if (!hasOpened) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ImageComponent className={styles["bazaarvoice-review-success-modal__icon"]} src="/assets/icons/wand_stars.svg" alt="" height={96} width={96} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== formatMessage) {
    t2 = formatMessage("headline");
    $[1] = formatMessage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== titleId) {
    t3 = <h3 id={titleId} className="h3 bold">{t2}</h3>;
    $[3] = t2;
    $[4] = titleId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== formatMessage) {
    t4 = formatMessage("body");
    $[6] = formatMessage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <p className={styles["bazaarvoice-review-success-modal__body"]}>{t4}</p>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== formatMessage) {
    t6 = formatMessage("closeButton");
    $[10] = formatMessage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => popupRef.current?.close();
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <ButtonComponent buttonType={ButtonType.PRIMARY} text={t6} onClick={t7} />;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t8) {
    t9 = <div className={styles["bazaarvoice-review-success-modal"]}>{t1}{t3}{t5}{t8}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isOpen || $[20] !== onClosed || $[21] !== t9 || $[22] !== titleId) {
    t10 = createPortal(<PopupComponent ref={popupRef} isOpen={isOpen} onClosed={onClosed} focusDialogOnOpen={true} closable={false} popupType={PopupType.CENTER} ariaLabelledBy={titleId}>{t9}</PopupComponent>, document.body);
    $[19] = isOpen;
    $[20] = onClosed;
    $[21] = t9;
    $[22] = titleId;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
export default BazaarvoiceReviewSuccessModalComponent;